import { render } from "./Stake.vue?vue&type=template&id=064294e0"
import script from "./Stake.vue?vue&type=script&setup=true&lang=js"
export * from "./Stake.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/stake/Stake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "064294e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('064294e0', __exports__)) {
    api.reload('064294e0', __exports__)
  }
  
  module.hot.accept("./Stake.vue?vue&type=template&id=064294e0", () => {
    api.rerender('064294e0', render)
  })

}


export default __exports__